import { MT_WEBVIEW } from '~/config/app.constants';

const DEFAULT_OLD_BRAND_COLOR = '#232A3E';

export const isWebView = () => window.navigator.userAgent.indexOf(MT_WEBVIEW) > -1;

/**
 * This function is used to set the default brand color for the learner layout.
 * TODO: This needs to be fixed, when we have done GA, then through script we will set the default brand color.
 */
export const setDefaultBrandColor = (color: string) => {
  const isOldBrandColor = color === DEFAULT_OLD_BRAND_COLOR;
  if (isOldBrandColor) {
    return '';
  }
  return color;
};
